<template>
    <table class="table">
        <thead>

        </thead>

        <tbody>

        </tbody>

        <tfoot>
            
        </tfoot>
    </table>
</template>

<script>
export default {
    
}
</script>
